module.exports = __webpack_public_path__ + "img/T2C_rc_1.7db045a5.png";